import { Injectable } from '@angular/core'
import { SignalStore } from '@awork/core/state/signal-store/signalStore'
import type { Permissions, ProjectRolePermissions } from '@awork/features/workspace/models/permissions.model'
import type { Role } from '@awork/features/workspace/models/role.model'

export interface PermissionsState {
  aiProduct: boolean
  pmProduct: boolean
  /** Whether Project times also protects budgets and planned effort (signed rollout switch). */
  bpe: boolean
  isAiPlanActive: boolean
  userId: string
  roleId: string
  isAdmin: boolean
  isGuest: boolean
  isBlocked: boolean
  signature: string
  permissions: Permissions[]
  projectRolesPermissions: ProjectRolePermissions[]
  deactivatedMenuItems: string[]
  roles: Role[]
}

/**
 * Creates the initial permission state with budget enforcement disabled.
 * @returns {PermissionsState} Initial permissions.
 */
export function createInitialState(): PermissionsState {
  return {
    aiProduct: true,
    pmProduct: true,
    bpe: false,
    isAiPlanActive: false,
    userId: null,
    roleId: null,
    isAdmin: false,
    isGuest: false,
    isBlocked: false,
    signature: null,
    permissions: [],
    projectRolesPermissions: [],
    deactivatedMenuItems: [],
    roles: []
  }
}

@Injectable({ providedIn: 'root' })
export class PermissionsStore extends SignalStore<PermissionsState> {
  constructor() {
    super({
      initialState: createInitialState(),
      name: 'permissions'
    })
  }
}
